// import { useEffect, useState, useCallback } from 'react';

import { useCallback, useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;

// export const useWindowResize = (onBreakpointChange) => {
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [currentBreakpoint, setCurrentBreakpoint] = useState(
//     window.innerWidth < MOBILE_BREAKPOINT ? 'mobile' : 'desktop'
//   );

//   const checkBreakpoint = useCallback((width) => {
//     const newBreakpoint = width < MOBILE_BREAKPOINT ? 'mobile' : 'desktop';
    
//     // Only update if the breakpoint actually changed
//     if (newBreakpoint !== currentBreakpoint) {
//       setCurrentBreakpoint(newBreakpoint);
//       onBreakpointChange?.(newBreakpoint, width);
//     }
//   }, [currentBreakpoint, onBreakpointChange]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       const newWidth = window.innerWidth;
      
//       // Only proceed if the width actually changed
//       if (newWidth !== windowWidth) {
//         clearTimeout(resizeTimer);
        
//         resizeTimer = setTimeout(() => {
//           setWindowWidth(newWidth);
//           checkBreakpoint(newWidth);
//         }, 250);
//       }
//     };

//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       clearTimeout(resizeTimer);
//     };
//   }, [windowWidth, checkBreakpoint]);

//   return {
//     windowWidth,
//     setWindowWidth,
//     breakpoint: currentBreakpoint,
//     isMobile: currentBreakpoint === 'mobile'
//   };
// };

// export const useWindowResize = (onBreakpointChange) => {
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [currentBreakpoint, setCurrentBreakpoint] = useState(
//     window.innerWidth < MOBILE_BREAKPOINT ? 'mobile' : 'desktop'
//   );
  
//   const checkBreakpoint = useCallback((width) => {
//     const newBreakpoint = width < MOBILE_BREAKPOINT ? 'mobile' : 'desktop';
    
//     console.log('Checking breakpoint:', {
//       width,
//       newBreakpoint,
//       currentBreakpoint: window.innerWidth < MOBILE_BREAKPOINT ? 'mobile' : 'desktop'
//     });

//     setWindowWidth(width);
    
//     // Force breakpoint update based on current width
//     const actualBreakpoint = width < MOBILE_BREAKPOINT ? 'mobile' : 'desktop';
//     if (actualBreakpoint !== currentBreakpoint) {
//       console.log('Updating breakpoint from', currentBreakpoint, 'to', actualBreakpoint);
//       setCurrentBreakpoint(actualBreakpoint);
//       onBreakpointChange?.(actualBreakpoint, width);
//     }
//   }, [currentBreakpoint, onBreakpointChange]);

//   useEffect(() => {
//     const handleResize = () => {
//       const newWidth = window.innerWidth;
//       checkBreakpoint(newWidth);
//     };

//     // Initial check
//     handleResize();

//     // Debounced resize handler
//     let resizeTimer;
//     const debouncedResize = () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(handleResize, 250);
//     };

//     window.addEventListener('resize', debouncedResize);

//     return () => {
//       window.removeEventListener('resize', debouncedResize);
//       clearTimeout(resizeTimer);
//     };
//   }, [checkBreakpoint]);

//   // Force update of breakpoint whenever window width changes
//   useEffect(() => {
//     const currentWidth = window.innerWidth;
//     const actualBreakpoint = currentWidth < MOBILE_BREAKPOINT ? 'mobile' : 'desktop';
//     console.log('act',actualBreakpoint);
//     console.log('cur', currentWidth);
//     console.log('win', windowWidth);
//     console.log('cb',currentBreakpoint);
    
    
//     console.log('on',onBreakpointChange(actualBreakpoint, currentBreakpoint));
    
    
//     if (actualBreakpoint !== currentBreakpoint) {
//       console.log('Force updating breakpoint due to width change:', {
//         width: currentWidth,
//         newBreakpoint: actualBreakpoint,
//         oldBreakpoint: currentBreakpoint
//       });
//       setCurrentBreakpoint(actualBreakpoint);
//       onBreakpointChange?.(actualBreakpoint, currentWidth);
//     }
//   }, [windowWidth, currentBreakpoint, onBreakpointChange]);

//   return {
//     windowWidth,
//     breakpoint: currentBreakpoint,
//     isMobile: windowWidth < MOBILE_BREAKPOINT // Use direct width check instead of breakpoint state
//   };
// };
export const useWindowResize = (onBreakpointChange) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentBreakpoint, setCurrentBreakpoint] = useState(
    window.innerWidth < MOBILE_BREAKPOINT ? 'mobile' : 'desktop'
  );

  const checkBreakpoint = useCallback((width) => {
    const newBreakpoint = width < MOBILE_BREAKPOINT ? 'mobile' : 'desktop';
    
    // console.log('Checking breakpoint:', {
    //   currentWidth: width,
    //   newBreakpoint,
    //   currentBreakpoint
    // });

    // Update width first
    setWindowWidth(width);
    
    // Then check if breakpoint changed
    if (newBreakpoint !== currentBreakpoint) {
      console.log('Breakpoint changing:', {
        from: currentBreakpoint,
        to: newBreakpoint,
        width
      });
      setCurrentBreakpoint(newBreakpoint);
      if (onBreakpointChange) {
        // Pass the numeric width, not the breakpoint string
        onBreakpointChange(newBreakpoint, width);
      }
    }
  }, [currentBreakpoint, onBreakpointChange]);

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      checkBreakpoint(newWidth);
    };

    // Initial check
    handleResize();

    // Debounced resize handler
    const debouncedResize = debounce(handleResize, 250);
    window.addEventListener('resize', debouncedResize);

    return () => {
      window.removeEventListener('resize', debouncedResize);
    };
  }, [checkBreakpoint]);

  return {
    windowWidth,
    breakpoint: currentBreakpoint,
    isMobile: windowWidth < MOBILE_BREAKPOINT
  };
};
const debounce = (fn, delay) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
};
